"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentLabelsProvider = exports.useComponentLabelsContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var defaultLabels = {
    accessTypeLabel: "access-type-label",
    accessRegimeLabel: "access-regime-label",
    removeAccessGranteeTooltip: "remove-access-grantee-tooltip",
    removeAccessCreatorTooltip: "remove-access-creator-tooltip",
};
var LabelsContext = react_1.default.createContext(defaultLabels);
/**
 * @internal
 */
exports.useComponentLabelsContext = function () { return react_1.useContext(LabelsContext); };
/**
 * @internal
 */
exports.ComponentLabelsProvider = function (props) {
    var children = props.children, labels = props.labels;
    return react_1.default.createElement(LabelsContext.Provider, { value: labels }, children);
};
//# sourceMappingURL=ComponentLabelsContext.js.map